/*
 * photo-list 照片网格块
 * Schema: { title?, photos: [{ url, thumbnail?, time?, address?, ... }], has_more? }
 */
import React, { useState } from 'react'
import { tryParseJson, PhotoListData } from './types'
import { useInvalidBlockWarning } from './useInvalidBlockWarning'
import { ImagePreview } from '../ImagePreview'
import './PhotoListBlock.scss'

interface PhotoListBlockProps {
  code: string
}

export const PhotoListBlock: React.FC<PhotoListBlockProps> = ({ code }) => {
  const data = tryParseJson<PhotoListData>(code)
  const [previewSrc, setPreviewSrc] = useState<string | null>(null)

  // 流式中 JSON 还没收齐时 tryParseJson 返回 null，silent 不渲染占位，
  // 避免气泡里闪一下"📷 照片列表数据无效"再切走（对齐 FileListBlock）；
  // 流式结束后仍无效 → useInvalidBlockWarning 会 console.warn 留排查线索。
  const valid = !!data && Array.isArray(data.photos) && data.photos.length > 0
  useInvalidBlockWarning('photo-list', code, valid)
  if (!data || !Array.isArray(data.photos) || data.photos.length === 0) {
    return null
  }

  return (
    <div className="aiClerk-block-photoList">
      {data.title && (
        <div className="aiClerk-block-photoList__title">{data.title}</div>
      )}
      <div className="aiClerk-block-photoList__grid">
        {data.photos.map((p, i) => (
          <div
            key={i}
            className="aiClerk-block-photoList__item"
            onClick={() => setPreviewSrc(p.url)}
          >
            <img
              src={p.thumbnail || p.small_url || p.url}
              alt={p.title || `photo-${i + 1}`}
              loading="lazy"
            />
            <div className="aiClerk-block-photoList__info">
              {p.time && (
                <div className="aiClerk-block-photoList__time">{p.time}</div>
              )}
              {p.address && (
                <div className="aiClerk-block-photoList__addr">{p.address}</div>
              )}
            </div>
            {p.media_type && /video/i.test(p.media_type) && (
              <div className="aiClerk-block-photoList__play">▶</div>
            )}
          </div>
        ))}
      </div>
      {data.has_more && (
        <div className="aiClerk-block-photoList__more">… 更多照片</div>
      )}

      <ImagePreview
        src={previewSrc}
        alt="照片预览"
        onClose={() => setPreviewSrc(null)}
      />
    </div>
  )
}
